// eslint-disable-next-line import/prefer-default-export
export const MAX_INTEGER_VALUE = 2147483647;

export enum NotificationType {
  ALL = 'all',
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
  PROGRESS = 'progress',
}
